(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ann]').forEach(function (ann) {
    if (ann.dataset.mode !== 'marquee') {
      var items = ann.querySelectorAll('.ann__item');
      if (items.length > 1) {
        var i = 0;
        var spd = (parseFloat(getComputedStyle(ann).getPropertyValue('--ann-speed')) || 4) * 1000;
        if (spd < 2000) spd = 4000;
        setInterval(function () {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, spd);
      }
    }
  });

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var out = el.querySelector('[data-cd]');
    if (!out) return;
    function target() {
      var d = el.getAttribute('data-deadline');
      if (d) { var t = new Date(d).getTime(); if (!isNaN(t)) return t; }
      var n = new Date();
      return new Date(n.getFullYear(), n.getMonth(), n.getDate(), 23, 59, 59).getTime();
    }
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var diff = target() - Date.now();
      if (diff < 0) diff = 0;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-bo]');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-faq]');
  roots.forEach(function (root) {
    root.querySelectorAll('.faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var isOpen = item.classList.contains('is-open');
        root.querySelectorAll('.faq__item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  });
  if (!('IntersectionObserver' in window)) { roots.forEach(function (r) { r.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.1 });
  roots.forEach(function (r) { io.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-g]');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var h = document.querySelector('[data-header]');
  if (!h) return;
  var onScroll = function () {
    if (window.scrollY > 12) { h.classList.add('is-scrolled'); }
    else { h.classList.remove('is-scrolled'); }
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-journey"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-dj]');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.08 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-ls]');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.1 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var select = form.querySelector('[data-variant-select]');
  var dataEl = form.querySelector('[data-variant-data]');
  if (!select || !dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var priceEl = document.querySelector('[data-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var atcBtn = form.querySelector('[data-atc-btn]');
  var stickyBtn = document.querySelector('[data-sticky-add]');
  var addLabel = atcBtn ? atcBtn.textContent.trim() : 'Add to cart';
  var soldLabel = 'Sold out';

  select.addEventListener('change', function () {
    var v = variants[select.value];
    if (!v) return;
    if (priceEl) priceEl.textContent = v.price;
    if (stickyPrice) stickyPrice.textContent = v.price;
    [atcBtn, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !v.available;
      btn.textContent = v.available ? addLabel : soldLabel;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-nl]');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-tb]');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10) || 0;
    if (reduce || target === 0) { el.textContent = fmt(target); return; }
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function reveal(root) {
    root.classList.add('is-in');
    root.querySelectorAll('.tb__val').forEach(countUp);
  }

  if (!('IntersectionObserver' in window)) { roots.forEach(reveal); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); } });
  }, { threshold: 0.3 });
  roots.forEach(function (r) { io.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-props"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-vp]');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 });
  sections.forEach(function (s) { io.observe(s); });
})();

  } catch(e) { console.error(e); }
})();
})();
